module.exports = __webpack_public_path__ + "static/media/viva2.7b963826.jpg";